// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-loading-dots-dots-bgxxa{height:32px;width:32px;color:var(--color-primary)}.components-loading-dots-dots-bgxxa.components-loading-dots-white-bffwu{color:#fff}.components-loading-dots-loading-zolkw{display:flex;justify-content:center;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dots": "components-loading-dots-dots-bgxxa",
	"white": "components-loading-dots-white-bffwu",
	"loading": "components-loading-dots-loading-zolkw"
};
module.exports = ___CSS_LOADER_EXPORT___;
